import React, {useEffect, useState} from 'react'
import {DateRange, Loader, Navigation, ScrollableDynamicTable, Button, TOAST} from "../../../../../../retro";
import Moment from 'moment'
import {get} from "../../../../../Network/Axios";
import {useHistory} from "react-router-dom";
import RBAC from 'App/HOCs/RBAC';
import ROLES from 'App/Constants/Roles';
import { DownloadCsv } from 'retro/Utils';

export default function index() {
	const [Dates, setDates] = useState();
	const HISTORY = useHistory();
	const [loading] = useState(false)
	const [Data, SetData] = useState({
		total: 0,
		currentPage: 0,
		totalPages: 0,
		items: []
	});
	const [downloading, setDownloading] = useState(false);

	useEffect(()=>{
		if(Dates){
			get(`/meta/bus`,(e,r)=>{
				if(r){
					SetData({
						...r,
						currentPage: Dates.page ? Dates.page : 0,
						totalPages: r.totalPages > 0 ? r.totalPages : Data.totalPages,
						total: r.total > 0 ? r.total : Data.total
					})
				} else {
					Alert.handleError(e)
				}
			},{
				start:Dates.startDate,
				end:Dates.endDate,
				offset:Dates.page
			})
		}
	},[Dates])
	if(loading){
		return (
			<div>
				<div style={{
					margin:'0 -4rem',
					padding:'2rem 4rem',
					borderBottom:'1px solid #dedede'
				}}>
					<div className="flex horizontally center-vertically">
						<div className="flex-1">
							<DateRange  defaultValue={{
								startDate:Moment().add(-31,'d').valueOf(),
								endDate : Moment().valueOf()
							}}  onChange={()=>{}} className='' label='Export from and to' type='range'/>
						</div>
					</div>
				</div>
				<div className="pd6">
					<Loader/>
				</div>
			</div>
		)
	}

	const downloadData = () => {
		setDownloading(true);

		get('/meta/bus', (error, response) => {
			if (error) {
				setDownloading(false);
				return TOAST.handleError(error);
			}

			const headers = [
				'Trans Id',
				'Client Code',
				'Client Name',
				'Provider',
				'Payment Type',
				'Amount'
			];

			const data = response.items.map(booking => [
				booking.transId,
				booking.client.code,
				booking.client.name,
				booking.provider,
				booking.paymentType,
				booking.amount
			]);

			const csvData = [headers, ...data]

			DownloadCsv(
				`bus_bookings_${Moment(Dates.startDate).format('DD_MM_YYYY')}_${Moment(Dates.endDate).format('DD_MM_YYYY')}.csv`,
				csvData
			);
			setDownloading(false);
		}, {
			start: Dates.startDate,
			end: Dates.endDate
		});
	};

	let items = [];
	Data.items.forEach(item=>{
		items.push({
			content: item,
			render: [
				item.transId,item.client.code,item.client.name,item.provider,item.paymentType
				,item.amount,{content:(<p className="fw-bold pointer" onClick={()=>{
						HISTORY.push(`/app/apps/meta/transaction/${item.transId}`)
					}}>View</p>)}

			].map(title=>{
				if(title.content){
					return {weight:2,children:title.content}
				}else{
					return {weight:2,title}
				}
			})
		})
	})
	return (
		<div style={{width:'100%'}}>
            <Navigation backUrl={'back'} title="Bus Bookings" chips={['Meta',"Bus","Bookings"]} description="Bus bookings appears below."/>
			<div style={{
				margin:'0 -4rem',
				padding:'2rem 4rem',
				borderBottom:'1px solid #dedede'
			}}>
				<div className="flex horizontally center-vertically">
					<div className="flex-1">
						<DateRange  defaultValue={{
							startDate:Moment().add(-31,'d').valueOf(),
							endDate : Moment().valueOf()
						}}  onChange={dates=>{
							setDates({
								...dates,
								page:0
							})
						}} className='' label='Export from and to' type='range'/>
					</div>
				</div>
			</div>
			<div>
				<RBAC role={ROLES.REPORTS}>
					<Button onClick={downloadData} className='btn btn-black' loading={downloading}>
						Download Data
					</Button>
				</RBAC>
				<ScrollableDynamicTable
					autoTrigger={false}
					tableStyle={{
						borderSpacing: 0
					}}
					width={150}
					search={Dates}
					setPage={page => {
						setDates({
							...Dates,
							page,
							total:Dates.totalPages
						})
					}}
					data={{
						current: Data.currentPage,
						total: Data.totalPages,
						items
					}} headers={[
					"Trans Id","Client Code","Client Name","Provider","Payment Type",
					"Amount","Actions"
				].map((item)=>({
					weight: 2,
					title: item,
				}))}/>
			</div>
        </div>
	)
}
